<template>
  <v-layout
    fill-height
    column
  >                
    <v-carousel
      height="100vh"
      interval="8000"
      hide-delimiter-background
      show-arrows-on-hover
      v-model="currentIndex"
    >
      <v-carousel-item
        v-for="(item,i) in items"
        :key="i"
        :src="isMobile ? item.srcMobile : item.srcDesktop"
      >
        <v-row
          class="textPosition"
          :class="{ mobile: isMobile }"
        >
          <v-col :class="{ 
              'ml-6': isMobile, 
              'mt-6': isMobile, 
              'ml-12': !isMobile, 
              'mt-12': !isMobile,
              content: isMobile
              }">
            <div class="text-h5 font-weight-thin text--lighten-1 mb-8" :style="item.color">
              {{ $t('hello', { user }) }}
            </div>
            <v-row>
              <v-col :cols="isMobile ? '12' : item.titleCols">
                <span class="text-h4" :style="item.color">{{ item.title }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="isMobile ? '12' :item.paragraphCols">
                <div class="text-h6 font-weight-light" :style="item.color">{{ item.paragraph }}</div>          
              </v-col>
            </v-row>
            <v-row v-if="item.buttonLabel">
              <v-col :cols="item.paragraphCols">
                <v-btn 
                    :href="item.buttonLink" 
                    target="_blank" 
                    color="secondary"
                    x-large
                    class="rounded-xl"
                  >{{ item.buttonLabel }}</v-btn>          
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-carousel-item>
    </v-carousel>
  </v-layout>        
</template>

<script>
import axios from 'axios'
import config from '@/config'
import utils from '@/utils';

export default {
  name: 'ViewHome',
  data() {
    return {
      user: '',
      items: [],
      currentIndex: 0
    }
  },
  async mounted () {
    await this.loadAuth();
    await this.getBanners();
  },
  methods: {
    async getBanners() {
      let country = config.VUE_APP_COUNTRY
      await axios.get(`${config.VUE_APP_API_URL}venusa/banner`, { params: { unidadePais: country } })
      .then(({ data }) => {
        const { lista } = data

        lista && lista.forEach((el) => {
            const {DESKTOP, EXTENSAO_DESKTOP, MOBILE, EXTENSAO_MOBILE, TEXT, BUTTON, LINK, TITLE, COLOR} = el

            const banner = {
              srcMobile: `data:image/${EXTENSAO_MOBILE};base64,${MOBILE}`,
              srcDesktop: `data:image/${EXTENSAO_DESKTOP};base64,${DESKTOP}`,
              title: TITLE,
              paragraph: TEXT,
              titleCols: this.$vuetify.breakpoint.xl ? 7 : 5,
              paragraphCols: this.$vuetify.breakpoint.xl ? 6 : 5,
              buttonLabel: BUTTON,
              buttonLink: LINK,
              color: COLOR == null ? 'color: #FFFFFF' : 'color:' + COLOR,
          }
          this.items.push(banner)
        })
      }).catch((error) => {
        console.log(error)
        this.items = this.defaultBanners
      })
    },

    async loadAuth() {
      if (this.$msal.isAuthenticated()){
        let azureb2c = await this.$msal.data.user;
        let name = azureb2c.idToken.name;
        this.user = name;
      } else if (this.isSignUpPage()) {
        this.isAuthLoading = false;
      } else {
        this.$msal.signIn();
      }
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
    countryConfig() {
      return utils.getCountryConfig()
    },
    defaultBanners() {
      return [
        {
            srcMobile: require('@/assets/img/tigre-home-first-min.jpg'),
            srcDesktop: require('@/assets/img/tigre-home-first-min.jpg'),
            title: 'Sea desde Casa o desde la Fábrica',
            paragraph: 'El Grupo Tigre es una vez más reconocido como Great Place to Work. Nuestra misión es ser, además de empresa, un excelente hogar para trabajar y crecer. Y eso nos enorgullece mucho.',
            titleCols: 5,
            paragraphCols: 5,
            buttonLabel: '¡CONTACTANOS!',
            buttonLink: this.countryConfig.AYUDA.LINK ?? '#'
        },
        {
          srcMobile: require('@/assets/img/tigre-home-second-min.png'),
          srcDesktop: require('@/assets/img/tigre-home-second-min.png'),
          title: 'NOS ACERCAMOS AL FUTURO PARA ACERCARTE A TUS PEDIDOS',
          paragraph: 'Presentemos la nueva herramienta tecnológica para entregas seguras',
          titleCols: 7,
          paragraphCols: 6,
          buttonLabel: '¡CONTACTANOS!',
          buttonLink: this.countryConfig.AYUDA.LINK ?? '#'
        },
      ]
    } 
  }
}
</script>

<style scoped lang="sass">
.textPosition
  top: 10vh
  left: 10vh
  position: absolute

  &.mobile
    top: 0
    left: 0
    position: relative
    width: 85vw
    height: 100%

    .content
      .text-h4
        font-size: 1.5rem !important
      .text-h6
        font-size: 1rem !important
.fade-transition-enter-active,
.fade-transition-leave-active
  transition-duration: 0.5s
  transition-property: opacity
  transition-timing-function: ease

.fade-transition-enter,
.fade-transition-leave-active
  opacity: 0
</style>